/* Component Dependencies */
var pageHeaderTemplate = require('templates/pageHeader.hbs');
var pageHeaderSubHeadingTemplate = require('templates/pageHeader-subHeading.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

AriesComponent.create({
  type: 'pageHeader',
  template: {
    'pageHeader': pageHeaderTemplate,
    'pageHeader-subHeading' : pageHeaderSubHeadingTemplate
  },
  subscribe: {
    'TOGGLE_PAGE_HEADER': 'togglePageHeader',
    'SNA': 'showCancellationPolicy'
  },
  
  showCancellationPolicy: function (data) {
  	console.log("pageheader2");
  	if(data === true){
  		$(".tile-pageHeader").removeClass('is-hidden'); 
   }
  },

  /**
    * This function is used to toggle the component state (show/hide)
    * @returns {Boolean} Operation Succeeded or not
    */
  togglePageHeader: function(showHeader) {
    if(showHeader){
      this.$el.show();
    } else {
      this.$el.hide();
   }
    return true;
  }
});
